import { createIcon } from '@chakra-ui/react'

const IconDownload = createIcon({
  displayName: 'IconDownload',
  viewBox: '0 0 24 24',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"
    />
  )
})

export default IconDownload
